export default __webpack_public_path__ + "bf2ed33529951359fea876604fbdf836.woff2";